import React, { useState, useContext } from 'react';
import {
  Box,
  Autocomplete,
  Typography,
  TextField,
  FormControl,
} from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FONT_SIZE } from '../../Variables';
import { PetitionPageCtx } from '../../context/PetitionContext';

export const NewSignerForm = (props) => {
  const { t } = useTranslation();
  const { userCountryFromIP , userZipFromIP} = useContext(PetitionPageCtx);
  const [inputValue, setInputValue] = useState(''); // Used for the country list (inner text field of autocomplete component)
  const [selectedCountry, setSelectedCountry] = useState(userCountryFromIP ? userCountryFromIP : ''); // Used for the country list

  const onChange = (fieldName, e) => {
    // Personal info changed: calls the function in the parent component
    props.handleUserDataChange(fieldName, e.target.value);
  };

  const handleCountryChange = (e, newValue) => {
    // Triggered when the selected country changed
    if (!newValue) {
      setSelectedCountry(''); // No selected country
    } else {
      setSelectedCountry(newValue.code); // Updates the state var
    }
    props.handleUserDataChange('country', newValue?.code ?? null); // Updates the personal info prop using the function provided by the parent
  };

  useEffect(() => {
    // Triggered when the selected country changed
    setSelectedCountry(props.country);
  }, [props.country]);

  return (
    <Box>
      {props.lang === 'hu' ? (
        <>
          <FormControl fullWidth sx={{ fontSize: FONT_SIZE.smaller }}>
            <TextField
              variant={'outlined'}
              label={
                <Typography sx={{ fontSize: FONT_SIZE.medium }}>
                  {t('petition_form.last_name') + ' *'}
                </Typography>
              }
              sx={{ marginBottom: '10px' }}
              InputProps={{
                style: { fontSize: FONT_SIZE.medium },
              }}
              inputProps={{ 'data-testid': 'form-last_name' }}
              onChange={(e) => onChange('lastName', e)}
              value={props.lastName}
              error={!props.lastName || props.lastName === ''}
              helperText={
                !props.lastName || props.lastName === ''
                  ? t('petition_form.required')
                  : ''
              }
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              variant={'outlined'}
              label={
                <Typography sx={{ fontSize: FONT_SIZE.medium }}>
                  {t('petition_form.first_name') + ' *'}
                </Typography>
              }
              sx={{ marginBottom: '10px' }}
              InputProps={{
                style: { fontSize: FONT_SIZE.medium },
              }}
              inputProps={{ 'data-testid': 'form-first_name' }}
              onChange={(e) => onChange('firstName', e)}
              value={props.firstName}
              error={!props.firstName || props.firstName === ''}
              helperText={
                !props.firstName || props.firstName === ''
                  ? t('petition_form.required')
                  : ''
              }
            />
          </FormControl>
        </>
      ) : (
        <>
          <FormControl fullWidth>
            <TextField
              variant={'outlined'}
              label={
                <Typography sx={{ fontSize: FONT_SIZE.medium }}>
                  {t('petition_form.first_name') + ' *'}
                </Typography>
              }
              sx={{ marginBottom: '10px' }}
              InputProps={{
                style: { fontSize: FONT_SIZE.medium },
              }}
              inputProps={{ 'data-testid': 'form-first_name' }}
              onChange={(e) => onChange('firstName', e)}
              value={props.firstName}
              error={!props.firstName || props.firstName === ''}
              helperText={
                !props.firstName || props.firstName === ''
                  ? t('petition_form.required')
                  : ''
              }
            />
          </FormControl>
          <FormControl fullWidth sx={{ fontSize: FONT_SIZE.smaller }}>
            <TextField
              variant={'outlined'}
              label={
                <Typography sx={{ fontSize: FONT_SIZE.medium }}>
                  {t('petition_form.last_name') + ' *'}
                </Typography>
              }
              sx={{ marginBottom: '10px' }}
              InputProps={{
                style: { fontSize: FONT_SIZE.medium },
              }}
              inputProps={{ 'data-testid': 'form-last_name' }}
              onChange={(e) => onChange('lastName', e)}
              value={props.lastName}
              error={!props.lastName || props.lastName === ''}
              helperText={
                !props.lastName || props.lastName === ''
                  ? t('petition_form.required')
                  : ''
              }
            />
          </FormControl>
        </>
      )}
      <Autocomplete
        id="country-select-demo"
        label={
          <Typography sx={{ fontSize: FONT_SIZE.medium }}>
            {t('petition_form.choose_a_country') + ' *'}
          </Typography>
        }
        sx={{ marginBottom: '10px' }}
        options={
          props.countries.find((el) => el.code === props?.lang?.toUpperCase())
            ? [
                ...props.countries.filter(
                  (el) => el.code === props.lang.toUpperCase()
                ),
                ...props.countries.filter(
                  (el) => el.code !== props.lang.toUpperCase()
                ),
              ]
            : props.countries
        }
        autoHighlight
        getOptionLabel={(option) => t(option.label ?? '')}
        value={props.countries.find((el) => el.code === props.country) ?? null}
        onChange={handleCountryChange}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        renderOption={(props, option, index) => (
          <Box
            component="li"
            /* sx={{ '& > img': { mr: 2, flexShrink: 0 } }} */
            {...props}
            key={`countryListItem-${index}-${option.code}`}
          >
            {/* <img
                            loading="lazy"
                            width="20"
                            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                            alt="country flag"
                        /> */}
            <Typography sx={{ fontSize: FONT_SIZE.medium }}>
              {option.label} ({option.code})
            </Typography>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              <Typography sx={{ fontSize: FONT_SIZE.medium }}>
                {t('petition_form.choose_a_country') + ' *'}
              </Typography>
            }
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
              'data-testid': 'form-country-selector'
            }}
            InputProps={{
              ...params.InputProps,
              style: { fontSize: FONT_SIZE.medium },
            }}
            error={!props.countries.find((el) => el.code === props.country)}
            helperText={
              !props.countries.find((el) => el.code === props.country)
                ? t('petition_form.required')
                : ''
            }
          />
        )}
      />
      {props.countries.find((el) => el.code === selectedCountry)
        ?.zip_code_required === 1 || true ? ( // Update: zip code text field always shown
        <FormControl fullWidth>
          <TextField
            variant={'outlined'}
            label={
              <Typography sx={{ fontSize: FONT_SIZE.medium }}>
                {t('petition_form.zip_code') + ' *'}
              </Typography>
            }
            sx={{ marginBottom: '10px', fontSize: FONT_SIZE.medium }}
            InputProps={{
              style: { fontSize: FONT_SIZE.medium },
            }}
            inputProps={{ 'data-testid': 'form-postcode' }}
            onChange={(e) => {
              onChange('zipCode', e);
            }}
            value={props.zipCode}
            disabled={/*selectedCountry === ''*/ false}
            error={
              props.zipCode === null ||
              props.zipCode === undefined ||
              props.zipCode === ''
            }
            helperText={
              !props.zipCode || props.zipCode === ''
                ? t('petition_form.required')
                : ''
            }
          />
        </FormControl>
      ) : null}
      {/*
                props.country !== "" ?
                    (
                        props.gdprCountries.indexOf(props.country) > -1 ?
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={props.gdpr} 
                                            onChange={e => { props.handleUserDataChange('gdpr', e.target.checked); }}
                                        />
                                    }
                                    label={<Typography sx={{fontSize: FONT_SIZE.small}}>{t("petition_form.gdpr_consent")}</Typography>}
                                />
                            </FormGroup>
                            :
                            null
                    )
                    : null
                                */}
    </Box>
  );
};
